import moment from "moment";

import { Calendar } from "primereact/calendar";
import { classNames } from "primereact/utils";

export default function FormCalendar(props) {
  const {
    className,
    setting: { Controller, control, trigger, isSubmitted, isEdit = true },
    data: {
      name,
      placeholder = "",
      minDate,
      maxDate,
      view = "date",
      dateFormat = "yy-mm-dd",
      disabled = false,
      saveFun = () => {},
    },
  } = props;

  const onChange = (e, field) => {
    field.onChange(e.value ? moment(e.value).format("YYYY/MM/DD") : null);

    saveFun();

    if (isSubmitted) {
      trigger();
    } else {
      trigger(field.name);
    }
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <div className={classNames("flex align-items-center", className)}>
            <Calendar
              id={field.name}
              className={classNames(
                { "p-invalid": fieldState.invalid },
                "w-full"
              )}
              {...field}
              value={field.value ? new Date(field.value) : null}
              onChange={(e) => onChange(e, field)}
              placeholder={placeholder}
              minDate={minDate ? new Date(minDate) : null}
              maxDate={maxDate ? new Date(maxDate) : null}
              view={view}
              dateFormat={dateFormat}
              disabled={!isEdit || disabled}
              showIcon
              showButtonBar
            />
          </div>
        )}
      />
    </>
  );
}
